(function () {
  var mercadoPago = 'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/Logo-blanco-mercado-pago.webp?v=1786206951';
  var otherLogos = [
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/1_d654fa70-70a6-42fa-9075-14df79e960fb.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/2_fdd9c0af-1007-433a-bf6a-92cd77c271a8.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/3_2ce9aa15-530a-4d73-af02-49515aef83a3.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/4_72880159-ca03-4412-b213-54d2591b5588.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/5_8e92b965-450f-47be-96d6-cc3749b5c8e3.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/6_cbfb303f-2018-4696-8e42-e267c6974d4a.webp?v=1786205352',
    'https://cdn.shopify.com/s/files/1/0902/2121/6055/files/7_a666f4fe-8a9f-4acb-a57b-f0170a3c3a66.webp?v=1786205352'
  ];

  if (!document.getElementById('payment-methods-style')) {
    var style = document.createElement('style');
    style.id = 'payment-methods-style';
    style.textContent =
      '.payment-methods{width:100%;max-width:480px;margin:24px auto 0;}' +
      '.payment-methods__title{font-size:13px;font-weight:600;color:#fff;margin:0 0 14px;' +
      'text-align:center;text-transform:uppercase;letter-spacing:0.5px;}' +
      '.payment-methods__bar{position:relative;width:100%;height:72px;}' +
      '.payment-methods__fixed{position:absolute;left:0;top:0;bottom:0;z-index:2;' +
      'display:flex;align-items:center;padding-right:24px;}' +
      '.payment-methods__fixed img{height:40px;width:auto;object-fit:contain;}' +
      '.payment-methods__scroll{position:absolute;inset:0;overflow:hidden;' +
      '-webkit-mask-image:linear-gradient(to right, transparent 0, transparent 130px, black 190px, black 100%);' +
      'mask-image:linear-gradient(to right, transparent 0, transparent 130px, black 190px, black 100%);}' +
      '.payment-methods__track{display:flex;align-items:center;gap:52px;height:100%;' +
      'width:max-content;padding-left:150px;animation:payment-methods-slide 18s linear infinite;}' +
      '.payment-methods__track img{height:36px;width:auto;object-fit:contain;flex-shrink:0;' +
      'filter:brightness(0) invert(1);}' +
      '@keyframes payment-methods-slide{from{transform:translateX(0);}to{transform:translateX(-50%);}}' +
      '@media (prefers-reduced-motion: reduce){.payment-methods__track{animation:none;}}' +
      '@media (max-width:480px){.payment-methods__bar{height:56px;}' +
      '.payment-methods__fixed img{height:30px;}.payment-methods__track img{height:26px;}' +
      '.payment-methods__track{padding-left:110px;gap:34px;}' +
      '.payment-methods__scroll{-webkit-mask-image:linear-gradient(to right, transparent 0, transparent 90px, black 140px, black 100%);' +
      'mask-image:linear-gradient(to right, transparent 0, transparent 90px, black 140px, black 100%);}}';
    document.head.appendChild(style);
  }

  var wrap = document.createElement('div');
  wrap.className = 'payment-methods';

  var title = document.createElement('div');
  title.className = 'payment-methods__title';
  title.textContent = 'Métodos de pago';
  wrap.appendChild(title);

  var bar = document.createElement('div');
  bar.className = 'payment-methods__bar';

  var fixed = document.createElement('div');
  fixed.className = 'payment-methods__fixed';
  var mpImg = document.createElement('img');
  mpImg.src = mercadoPago;
  mpImg.alt = 'Mercado Pago';
  fixed.appendChild(mpImg);

  var scroll = document.createElement('div');
  scroll.className = 'payment-methods__scroll';
  var track = document.createElement('div');
  track.className = 'payment-methods__track';

  var all = otherLogos.concat(otherLogos);
  all.forEach(function (src) {
    var img = document.createElement('img');
    img.src = src;
    img.alt = 'Medio de pago';
    img.loading = 'lazy';
    track.appendChild(img);
  });

  scroll.appendChild(track);
  bar.appendChild(scroll);
  bar.appendChild(fixed);
  wrap.appendChild(bar);

  var thisScript = document.currentScript;
  if (thisScript && thisScript.parentNode) {
    thisScript.parentNode.insertBefore(wrap, thisScript);
  } else {
    document.body.appendChild(wrap);
  }
})();